import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

function AppSelectionSummary({ selectedApps, bundleApps, onRemove }) {
  const totalCount = bundleApps.length + selectedApps.length;

  if (totalCount === 0) {
    return (
      <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }}>
        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
          <Typography variant="body2" color="text.secondary">
            Nessuna applicazione selezionata
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ mb: 2, bgcolor: '#f8f9fa' }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
          Applicazioni selezionate ({totalCount})
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
          {bundleApps.map(app => (
            <Chip
              key={app.id}
              label={app.name}
              size="small"
              icon={<LockIcon sx={{ fontSize: '14px !important' }} />}
              color="default"
            />
          ))}
          {selectedApps.map(app => (
            <Chip
              key={app.id}
              label={app.name}
              size="small"
              onDelete={() => onRemove(app.id)}
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
        {/* Hidden input per validazione form */}
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{ opacity: 0, height: 0, position: 'absolute' }}
          value={totalCount > 0 ? 'valid' : ''}
          required={true}
          readOnly
        />
      </CardContent>
    </Card>
  );
}

export default AppSelectionSummary;
